import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {ResultadoRegraService} from "../../resultado-regra/resultado-regra.service";
import {ResultadoRegra} from "../../resultado-regra/resultado-regra";
import {TipoExecucao} from "../../resultado-regra/resultado-regra/tipo-execucao";
import {indicate} from "../util/loading-indicate";
import {FormBuilder, FormControl, FormGroup} from "@angular/forms";
import {Subject} from "rxjs";
import {CarteiraService} from "../../carteira/carteira.service";
import {DetalheProcessamentoFilter} from "./detalhe-processamento-filter";


@Component({
    selector: 'app-modal-detalhe-processamento',
    templateUrl: './modal-detalhe-processamento.component.html',
    styleUrls: ['./modal-detalhe-processamento.component.scss']
})
export class ModalDetalheProcessamentoComponent implements OnInit {

    resultadoRegras: ResultadoRegra[] = [];

    expandedElement: ResultadoRegra;
    loading$: Subject<boolean> = new Subject<boolean>();
    page$: Subject<number> = new Subject<number>();
    paginationTotalPage = 1;
    totalRegistros = 0;
    private pageSize = 20;
    form: FormGroup;

    constructor(
        public formBuilder: FormBuilder,
        private readonly resultadoRegraService: ResultadoRegraService,
        private readonly carteiraService: CarteiraService,
        @Inject(MAT_DIALOG_DATA) private data: DetalheProcessamentoFilter,
        public dialogRef: MatDialogRef<ModalDetalheProcessamentoComponent>,
    ) {
    }

    ngOnInit(): void {
        this.form = this.formBuilder.group({
            carteiraId: new FormControl(),
            dataInicio: new FormControl(),
            dataFim: new FormControl(),
            page: new FormControl(0),
        });
        if (!this.data.dataInicio) {
            const carteiraId = this.data.carteiraId;
            this.carteiraService.findById(carteiraId)
            .pipe(indicate(this.loading$))
            .subscribe(value => {
                    const dataInicio = value.dataUltimoProcessamento;
                    const dataFim = value.dataUltimoProcessamento;
                    this.form.controls.dataFim.setValue(dataFim);
                    this.form.controls.dataInicio.setValue(dataInicio);
                    this.form.controls.carteiraId.setValue(carteiraId);
                    this.detail(carteiraId, dataInicio, dataFim, 0);
                }
            );
        } else {
            this.form.controls.dataFim.setValue(this.data.dataFim);
            this.form.controls.dataInicio.setValue(this.data.dataInicio);
            this.form.controls.carteiraId.setValue(this.data.carteiraId);
            this.detail(this.data.carteiraId, this.data.dataInicio, this.data.dataFim, 0);
        }
        this.page$.subscribe(value => {
            this.form.controls.page.setValue(value - 1);
            this.detail(this.form.controls.carteiraId.value, this.form.controls.dataInicio.value, this.form.controls.dataFim.value, value - 1);
        });
    }

    rowClicked(r: ResultadoRegra) {
        this.expandedElement = (this.expandedElement === r) ? null : r;
    }

    getTipoExecucao(tipoExecucao: string): string {
        return TipoExecucao.findTiposExecucao(tipoExecucao).name;
    }

    detail(carteiraId: number, dataInicio: Date, dataFim: Date, page: number) {
        this.resultadoRegras = [];
        this.totalRegistros = 0;
        this.resultadoRegraService
        .searchDetailProcess(carteiraId, dataInicio, dataFim, this.pageSize, page)
        .pipe(indicate(this.loading$))
        .subscribe(
            (r) => {
                if (r.metadata.totalElements > 0) {
                    if (r.metadata.size === 0) {
                        this.paginationTotalPage = 1;
                    } else {
                        this.paginationTotalPage = Math.ceil(
                            r.metadata.totalElements / r.metadata.size
                        );
                    }
                    this.totalRegistros = r.metadata.totalElements;
                    this.resultadoRegras = r.content.map(e =>
                        Object.assign(new ResultadoRegra(), e)
                    );
                    this.form.get("page").setValue(r.metadata.number);
                } else {
                    this.paginationTotalPage = 1;
                }
            }, error => {
                console.log(error)
            }
        );
    }

    updatePageSize($event: number): void {
        this.pageSize = $event;
        this.page$.next(1);
    }

    receiverPage(value) {
        this.page$.next(value);
    }

    closeDialog() {
        this.dialogRef.close();
    }

}
